import React from 'react';
import {  Modal } from 'react-bootstrap';
import '../util.css';

export default function LoadingModal(props) {
  return (
    <Modal
      {...props}
      bsSize="small"
      dialogClassName=" loader-modal"
    >
      <Modal.Body>
          <div className="loader"/>
      </Modal.Body>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/modal/util/LoadingModal.js